import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { useSelector } from 'react-redux';

import { AdfoxBanner } from 'shared/components/AdfoxBanner';
import { TAdfoxContextData, AdfoxContext } from 'shared/context/AdfoxContext';
import { useAdfoxPuids } from 'shared/context/AdfoxContext/internal/hooks/useAdfoxPuids';
import { selectIsNewbuildingPremiumRate } from 'shared/selectors/newbuildingPremiumRate';
import { IPParams } from 'shared/types/adfox';

const POST_VIEW_ANALYTICS_DATA: TAdfoxContextData['postViewAnalyticsData'] = {
  banner: {
    place: 'offerCard',
    name: 'StretchBanner',
  },
};
const P_PARAMS: IPParams = { p1: 'bvknz', p2: 'y' };
const SIZE: TAdfoxContextData['size'] = { width: '100%', minHeight: '200px' };

export const StretchBannerContainer: React.FC = () => {
  const stretchBannerRoot = React.useRef<Root | null>(null);
  const elementRef = React.useRef<HTMLElement | null>(null);

  const params = useAdfoxPuids(P_PARAMS);

  const isPremiumNewbuilding = useSelector(selectIsNewbuildingPremiumRate);

  const adfoxContextProviderValue = React.useMemo(
    (): TAdfoxContextData => ({
      postViewAnalyticsData: POST_VIEW_ANALYTICS_DATA,
      size: SIZE,
      params,
      isHidden: isPremiumNewbuilding,
    }),
    [isPremiumNewbuilding, params],
  );

  React.useEffect(() => {
    /* istanbul ignore next */
    if (!stretchBannerRoot.current) {
      const el = document.getElementById('adfox-stretch-banner');

      /* istanbul ignore next */
      if (el) {
        elementRef.current = el;
        stretchBannerRoot.current = createRoot(el);

        stretchBannerRoot.current.render(
          <AdfoxContext.Provider value={adfoxContextProviderValue}>
            <AdfoxBanner />
          </AdfoxContext.Provider>,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
